import { AllergieService } from "../../core/http/service/AllergieService";
import { PersonAllergieService } from "../../core/http/service/PersonAllergieService";
import BaseResponse from "../../models/core/BaseResponse";
// import BaseResponse from "../../models/core/BaseResponse";
// import { AppStorage } from "../../storage/AppStorage";

export const FETCH_TYPES = "FETCH_TYPES";

const sendToAnalytics = (action: string = "", error: any = null) => {
  console.error(action, error);
};

export const fetchAllergieAll = () => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: "",
      });
    } catch (error: any) {
      sendToAnalytics(error);
      throw error;
    }
  };
};


export const registerAllergieInPerson = (data: any) => {
  return async (dispatch: any) => {
    const service: PersonAllergieService = new PersonAllergieService();
    try {
      

      for(const item of data){
        await service.addAllergier(item)
      }

    } catch (error: any) {
      sendToAnalytics(error);
      throw error;
    }
  };
};



export const deleteAllergiePerson = (id: string) => {
  return async (dispatch: any) => {
    const service: PersonAllergieService = new PersonAllergieService();
    try {
      await service.deleteAllergiePerson(id);
    } catch (error: any) {
      sendToAnalytics(error);
      throw error;
    }
  };
};

export const getTypes = () => {
  return async (dispatch: any) => {
    const service: AllergieService = new AllergieService();
    try {
      const response: any = await service.getTypesAllergies();

      const arrayT: BaseResponse<any> = new BaseResponse().fromJSON(
        response.data
      );

      const types: any[] = [];
      let id = 1;

      arrayT.data.forEach((data: any) => {
        types.push({nome: data, id: id++});
      });      
      
      dispatch({
        type: FETCH_TYPES,
        types: types
    })
    } catch (error: any) {
      sendToAnalytics(error);
      throw error;
    }
  };
}
